import { render, staticRenderFns } from "./TipoDocumentos.vue?vue&type=template&id=bba19f14"
import script from "./TipoDocumentos.vue?vue&type=script&lang=js"
export * from "./TipoDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports